import { Children } from 'react';
import { Tag } from './components';
import { ITags } from './tags.models';
import * as S from './tags.style';

const Tags: React.FC<ITags> = ({ tags = [], toggleTags = undefined, variant, type }) => {
  if (tags.length === 0) {
    return null;
  }

  return (
    <S.Ul>
      {Children.toArray(
        tags.map((tag) => (
          <Tag
            key={tag.id}
            type={type}
            variant={variant}
            isSelected={tag.isSelected}
            onClick={() => toggleTags?.(tag)}
          >
            {tag?.label}
          </Tag>
        ))
      )}
    </S.Ul>
  );
};

export default Tags;
